import { useViewport } from "@xyflow/react";

/**
 * Thin wrapper over reactflow's `useViewport`. The canvas applies the live
 * viewport `{x, y, zoom}` as a CSS `transform` on `<WidgetLayer>` so widgets
 * pan and zoom in lockstep with the dot-grid background.
 *
 * Kept as its own file so module-specific canvases (VsmCanvas, future) can
 * compose the same viewport reading without duplicating the import.
 */
export function useCanvasViewport(): { x: number; y: number; zoom: number } {
  const { x, y, zoom } = useViewport();
  return { x, y, zoom };
}
